function buildRedeemBody(code, signUpData) {
  const data = signUpData ?? {};

  return {
    code: String(code ?? '').trim(),
    username: String(data.username ?? '').trim(),
    nickname: String(data.nickname ?? '').trim(),
    password: data.password,
  };
}

function buildLoginParams(username, password) {
  return {
    identification: String(username ?? '').trim(),
    password,
    remember: true,
  };
}

function submitRegistration({ request, login, reload, loaded, errorHandler, requestOptions, password }) {
  return request({ ...requestOptions, errorHandler })
    .then((response) => {
      const username = String(response?.username ?? '').trim();

      if (!username) {
        const error = new Error('Registration response is missing a username.');
        error.alert = {
          type: 'error',
          content: '注册失败，请刷新页面后重试。',
        };
        errorHandler(error);
        throw error;
      }

      return login(buildLoginParams(username, password), { errorHandler });
    })
    .then(reload, loaded);
}

export { buildLoginParams, buildRedeemBody, submitRegistration };
